import IconTooltipButton from '../../../../button/IconTooltipButton'
import { Chip, Divider, Skeleton, Typography } from '@mui/material'
import CustomAvatar from '../../../../avatar/Avatar'
import AvatarSkeleton from '../../../../avatar/AvatarSkeleton'
import CardKeyValue from '../../../../card/cardKeyValue'
import { SURVEY_TYPE_ABOUT_CLASSES, SURVEY_TYPE_ABOUT_USERS } from '../../constants/typeSurvey'
import { useSelector } from 'react-redux'

const InfoAboutData = ({ type, data = {}, onShareLink, loading }) => {
  const dataYears = useSelector((state) => state?.tenant?.years || [])
  const yearLevel = dataYears?.filter((y) => data?.yearLevel?.includes(y?._id))
  const levels = typeof data?.yearLevel?.[0] === 'string' ? yearLevel : data?.yearLevel || []

  return (
    <>
      <div className='flex gap-2 justify-between items-center pr-2 py-2'>
        <div className='flex gap-2 justify-start items-strech'>
          {data?.survey && (
            <CardKeyValue
              className='min-w-200px max-w-150px '
              title='Survey'
              lines={2}
              loading={loading}
              value={data?.survey || ''}
            />
          )}
          {SURVEY_TYPE_ABOUT_USERS.includes(type) && (
            <div className='flex items-center gap-4 '>
              {loading ? (
                <AvatarSkeleton size='medium' variant='rounded' />
              ) : (
                <CustomAvatar
                  size='medium'
                  variant='rounded'
                  alt={data?.code}
                  src={`photos/${data?.photo}`}
                />
              )}
              <div className='flex flex-col'>
                <Typography className='text-xl font-bold text-primary'>
                  {loading ? <Skeleton variant='text' width={100} /> : data?.code}
                </Typography>
                <Typography className='text-md '>
                  {loading ? (
                    <Skeleton variant='text' width={150} />
                  ) : (
                    `${data?.preferredName || data?.firstName} ${data?.lastName}`
                  )}
                </Typography>
                <div className='flex flex-wrap gap-1'>
                  {loading ? (
                    <Skeleton variant='text' width={110} />
                  ) : (
                    data?.roles?.map((role) => (
                      <Chip key={`user-${data?._id}-role-${role._id}`} size='small' label={role.name} />
                    ))
                  )}
                </div>
              </div>
            </div>
          )}
          {type === SURVEY_TYPE_ABOUT_CLASSES && (
            <>
              <div className='flex flex-col gap-2 px-2 py-1 rounded-md max-w-200px min-w-200px'>
                <Typography className='text-xl font-bold text-primary'>
                  {loading ? <Skeleton variant='text' /> : data?.code}
                </Typography>
                <div className='flex flex-wrap gap-1'>
                  {loading ? (
                    <Skeleton variant='text' width={110} />
                  ) : (
                    levels?.map((year) => (
                      <Chip key={`user-${data?._id}-role-${year?._id}`} size='small' label={year?.name} />
                    ))
                  )}
                </div>
              </div>
              <Divider orientation='vertical' flexItem />
              <div className='flex flex-col gap-1  px-2 py-1 rounded-md max-w-200px min-w-200px'>
                {onShareLink && (
                  <Typography className=' uppercase font-bold text-primary'>
                    #{data?.students?.length || 0} Students
                  </Typography>
                )}
                <Typography className='text-xs uppercase font-bold text-primary'>Teachers:</Typography>
                <div className='flex flex-wrap gap-1'>
                  {loading ? (
                    <Skeleton variant='text' width={110} />
                  ) : (
                    data?.teachers?.map((t) => (
                      <Chip
                        key={`user-${data?._id}-role-${t?._id}`}
                        variant='outlined'
                        size='small'
                        label={`${t?.preferredName || t?.firstName} ${t?.lastName}`}
                      />
                    ))
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        {onShareLink && (
          <IconTooltipButton
            disabled={loading}
            title='Share link'
            icon='share-alt'
            classNameIcon='text-2xl'
            onClick={() => onShareLink(data)}
          />
        )}
      </div>
    </>
  )
}

export default InfoAboutData
